export default __webpack_public_path__ + "static/media/apple.26a9c8e1.svg";